import { Injectable } from "@angular/core";
import { Http } from '@angular/http';
import { TypeModel, NewsBitModel, CategoryModel, FilterModel, OrderByModel, BookmarkedArticles } from './news.model';

import 'rxjs/add/operator/toPromise';

import firebase from 'firebase';

@Injectable()
export class NewsService {

  constructor(
    public http: Http,
  ) { }

  getTypes(): Promise<Array<TypeModel>> {

    try {
      return new Promise<Array<TypeModel>>((resolve, reject) => {
        firebase.database().ref('/news/types')
          .on('value', snapshot => {
            return resolve(snapshot.val());
          }, error => {
            this.handleError(error);
          });
      });
    }
    catch (error) {
      return Promise.reject(error);
    }
  }

  getCategories(): Promise<Array<CategoryModel>> {

    return new Promise<Array<CategoryModel>>((resolve, reject) => {
      firebase.database().ref('/news/categories')
        .on('value', snapshot => {
          return resolve(snapshot.val());
        }, error => {
          this.handleError(error);
        });
    });
  }

  getFeed(filter: FilterModel, orderBy: OrderByModel) {

    if (filter.filterActive) {
      if (filter.filterBy.includes("_id")) {
        return this.getFeedByFilterNumber(filter);
      }
      else {
        return this.getFeedByFilterString(filter);
      }
    }
    if (orderBy.orderByActive) {
      return this.getFeedByOrder(orderBy);
    }

    else {
      return this.getFeedWithoutFilter();
    }
  }

  getFeedByFilterString(filter: FilterModel): Promise<Array<NewsBitModel>> {

    return new Promise<Array<NewsBitModel>>((resolve, reject) => {
      firebase.database().ref('/news/feed')
        .orderByChild(filter.filterBy)
        .startAt(filter.filterValue)
        .endAt(filter.filterValue + '\uf8ff')
        .once('value', snapshot => {

          var obj = snapshot.val();

          if (obj) {

            for (let key in obj) {
              obj[key].id = key;
            }

            return resolve(Object.values(obj));
          }

          this.handleError("No feed found!");
        }, error => {
          this.handleError(error);
        });
    });
  }

  getFeedByOrder(orderBy: OrderByModel): Promise<Array<NewsBitModel>> {

    return new Promise<Array<NewsBitModel>>((resolve, reject) => {
      firebase.database().ref('/news/feed')
        .orderByChild('timestamp')
        .limitToFirst(10)
        .on('value', snapshot => {
          var obj = snapshot.val();

          if (obj) {

            for (let key in obj) {
              obj[key].id = key;
            }

            return resolve(Object.values(obj));
          }
        }, error => { this.handleError(error); })
    });
  }

  getFeedByFilterNumber(filter: FilterModel): Promise<Array<NewsBitModel>> {

    return new Promise<Array<NewsBitModel>>((resolve, reject) => {
      firebase.database().ref('/news/feed')
        .orderByChild(filter.filterBy)
        .equalTo(filter.filterValue)
        .once('value', snapshot => {

          var obj = snapshot.val();

          if (obj) {
            for (let key in obj) {
              obj[key].id = key;
            }

            return resolve(Object.values(obj));
          }

          this.handleError("No feed found!");
        }, error => {
          this.handleError(error);
        });
    });
  }

  getCategoryIdByName(name): Promise<any> {

    return new Promise<any>((resolve, reject) => {
      firebase.database().ref('/news/categories')
        .orderByChild('name')
        .equalTo(name)
        .once('value', snapshot => {
          if (snapshot.val())
            return resolve(Object.values(snapshot.val())[0]);

          this.handleError("No feed found!");
        });
    });
  }

  getFeedWithoutFilter(): Promise<Array<NewsBitModel>> {

    return new Promise<Array<NewsBitModel>>((resolve, reject) => {
      firebase.database().ref('/news/feed')
        .on('value', snapshot => {
          var obj = snapshot.val();

          if (obj) {

            for (let key in obj) {
              obj[key].id = key;
            }

            return resolve(Object.values(obj));
          }

          this.handleError("No feed found!");
        }, error => {
          this.handleError(error);
        });
    });
  }

  getFeedByCountry(country): Promise<Array<NewsBitModel>> {
    country = country.toLowerCase();
    var ref = firebase.database().ref('/news/rssFeed').child(country);

    return new Promise<Array<any>>((resolve, reject) => {

      ref.orderByKey()
        .limitToLast(10)
        .once('value', snapshot => {
          var obj = snapshot.val();

          if (obj) {
            for (let key in obj) {
              obj[key].id = key;
              obj[key].date = new Date(obj[key].date).toDateString();
              if (obj[key].date == "invalid") {
                obj[key].date = "";
              }
            }

            return resolve(this.reverseArray(Object.values(obj)));
          }

          return reject("No feed found!");
        }, error => {
          this.handleError(error);
        });
    });
  }

  getMoreFeedByCountry(country: string, index: string): Promise<Array<NewsBitModel>> {
    country = country.toLowerCase();
    var ref = firebase.database().ref('/news/rssFeed').child(country);

    return new Promise<Array<any>>((resolve, reject) => {

      ref.orderByKey()
        .endAt(index)
        .limitToLast(11)
        .once('value', snapshot => {
          var obj = snapshot.val();

          if (obj) {
            for (let key in obj) {
              obj[key].id = key;
              obj[key].date = new Date(obj[key].date).toDateString();
              if (obj[key].date == "invalid") {
                obj[key].date = "";
              }
            }

            var arr = Object.values(obj);
            arr = arr.splice(0, (arr.length - 1));

            return resolve(this.reverseArray(arr));
          }

          return reject("No feed found!");
        }, error => {
          this.handleError(error);
        });
    });
  }

  // var startAt = Object.keys(snapshot.val())[0];

  //         ref.orderByKey()
  //           .endAt(startAt)
  //           .limitToLast(11)
  //           .once('value', snap => {
  //             
  //           });

  addBookmark(uid: string, bookmark: BookmarkedArticles): Promise<any> {

    return new Promise<any>((resolve) => {

      firebase.database().ref('/news/savedArticles')
        .child(uid)
        .child(bookmark.newsId)
        .set(bookmark)
        .then(() => {
          return resolve();
        });
    });
  }

  checkBookmark(uid: string, bookmark: BookmarkedArticles): Promise<boolean> {

    return new Promise<boolean>((resolve) => {

      firebase.database().ref('/news/savedArticles')
        .child(uid)
        .child(bookmark.newsId)
        .once('value', snapshot => {
          if (snapshot.val()) {
            return resolve(true);
          } else {
            return resolve(false);
          }
        });
    });
  }

  getBookmarkedArticles(uid): Promise<Array<NewsBitModel>> {
    let result = new Array<NewsBitModel>(), tempObj;
    let savedArticlesRef = firebase.database().ref('/news/savedArticles/' + uid);
    let countryRssRef = firebase.database().ref('/news/rssFeed');

    return new Promise<Array<NewsBitModel>>((resolve, reject) => {

      savedArticlesRef
        .orderByChild('createdOn')
        .once('value', snapshot => {

          if (snapshot.val()) {

            tempObj = Object.values(snapshot.val()) as Array<BookmarkedArticles>;
            for (let obj of tempObj) {

              countryRssRef.child(obj.country)
                .child(obj.newsId)
                .once('value', snap => {
                  if (snap.val()) {
                    let tempSnap = snap.val();
                    tempSnap.id = snap.key;

                    if (tempSnap.date)
                      tempSnap.date = new Date(tempSnap.date).toDateString();
                    if (tempSnap.date == "invalid")
                      tempSnap.date = "";

                    result.push(tempSnap);
                  }
                });
            }

            return resolve(result.reverse());
          } else {
            return reject('No feed found!');
          }
        });
    });
  }

  removeBookmark(uid, nid) {

    return new Promise((resolve, reject) => {

      firebase.database().ref('/news/savedArticles').child(uid).child(nid).remove().then(response => {
        return resolve();
      }).catch(error => {
        this.handleError(error);
      })
    });
  }

  reverseArray(arr) {
    let revArr = new Array<Object>();

    for (let i = arr.length - 1; i >= 0; i--) {
      revArr.push(arr[i]);
    }

    return revArr;
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}


// WEBPACK FOOTER //
// ./src/pages/news/news.service.ts